import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsRadioButtonComponent } from "./ds-radio-button.component";
import { MatRadioModule } from "@angular/material/radio";

@NgModule({
  declarations: [DsRadioButtonComponent],
  imports: [CommonModule, MatRadioModule],
  exports: [DsRadioButtonComponent],
})
export class DsRadioButtonModule {}
